import { FunctionComponent, useContext } from 'react';
import { Card, TextField, Typography } from '@mui/material';
import { AppContext } from '../../providers/AppContext';
import useWindowDimensions from '../../hooks/dimension';

const textFieldStyle = {
    marginBottom: 8,
    marginLeft: 8,
    width: '75%'
};

interface GeneralInfoProps {
    handleDrag: any;
    handleDrop: any;
    id: any;
}

const GeneralInfo: FunctionComponent<GeneralInfoProps> = (props: GeneralInfoProps) => {

    const { changeData, fullName, description, username } = useContext(AppContext);
    const { height, width } = useWindowDimensions();


    return (
        <Card style={{
            display: 'flex',
            flexDirection: 'column',
            padding: 15,
            marginBottom: 15,
        }}>
            <div
                id={props.id}
                draggable={true}
                onDragStart={props.handleDrag}
                onDragOver={(e: any) => e.preventDefault()}
                onDrop={(e) => props.handleDrop(e, true)}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: 8
                }}>

                <Typography
                    variant='h5'
                    style={{
                        marginBottom: 8,
                    }}>
                    General Info
                </Typography>

                <div className='inline-start'>
                    <Typography
                        variant='h4'
                        style={{ marginBottom: 12, fontSize: (width && width < 400) ? 16 : (width && width < 480) ? 18 : (width && width < 600) ? 20 : 24, fontWeight: '700' }}>
                        Hi 👋, I'm
                    </Typography>

                    <TextField
                        id='outlined-basic'
                        placeholder='your name'
                        variant='standard'
                        size='small'
                        type={'text'}
                        style={{
                            marginBottom: 8,
                            marginLeft: 8,

                        }}
                        InputProps={{
                            style: { fontSize: (width && width < 400) ? 16 : (width && width < 480) ? 18 : (width && width < 600) ? 20 : 32, fontWeight: '700', paddingBottom: 0 },
                            disableUnderline: true
                        }}
                        onChange={(e) => changeData({
                            fullName: e.target.value
                        })}
                        value={fullName || ''} />
                </div>

                <div className={width && width > 600 ? 'inline-start' : 'column'}>
                    <Typography
                        variant='body1'
                        style={{ marginBottom: 8 }}>
                        I'm passionate on
                    </Typography>

                    <TextField
                        id='outlined-basic'
                        placeholder='describe about you'
                        variant='standard'
                        size='small'
                        style={{ ...textFieldStyle, marginLeft: width && width < 600 ? 0 : 8, marginBottom: width && width < 600 ? 12 : 8,  marginTop: width && width < 600 ? -8 : 0 }}
                        InputProps={{
                            disableUnderline: true
                        }}
                        onChange={(e) => changeData({
                            description: e.target.value
                        })}
                        value={description || ''}
                    />
                </div>

                <div className={width && width > 600 ? 'inline-start' : 'column'}>
                    <Typography
                        variant='body1'
                        style={{ marginBottom: 8 }}>
                        My GitHub username
                    </Typography>

                    <TextField
                        id='outlined-basic'
                        placeholder='username'
                        variant='standard'
                        size='small'
                        style={{ ...textFieldStyle, marginLeft: width && width < 600 ? 0 : 8,  marginBottom: width && width < 600 ? 12 : 8,  marginTop: width && width < 600 ? -8 : 0 }}
                        InputProps={{
                            disableUnderline: true
                        }}
                        onChange={(e) => changeData({
                            username: e.target.value
                        })}
                        value={username || ''} />
                </div>

            </div>
        </Card>
    );
}

export default GeneralInfo;